import { render } from "./Embark.vue?vue&type=template&id=01a15933&scoped=true"
import script from "./Embark.vue?vue&type=script&lang=js"
export * from "./Embark.vue?vue&type=script&lang=js"

import "./Embark.vue?vue&type=style&index=0&id=01a15933&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a15933"]])

export default __exports__